import '@fontsource/space-grotesk/700.css';  // Bold
import '@fontsource/space-grotesk/500.css';  // Medium

/**
 * VizBadger Logo Component
 * 
 * Uses Space Grotesk font with:
 * - "Viz" in bold (700)
 * - "Badger" in medium (500)
 * - Period color changes based on route
 * 
 * @param {string} periodColor - Color for the period (default: '#A26ECC')
 * @param {number} size - Font size in pixels (default: 24)
 * @param {string} className - Additional CSS classes
 */
export const Logo = ({ 
  periodColor = '#A26ECC', 
  size = 24,
  className = '' 
}) => {
  return (
    <div 
      className={`logo ${className}`}
      style={{ 
        fontFamily: 'Space Grotesk, sans-serif',
        fontSize: `${size}px`,
        letterSpacing: '-1.5px',
        color: '#2C3E50',
        display: 'flex',
        alignItems: 'baseline',
        lineHeight: 1.1,
      }}
    >
      <span style={{ fontWeight: 700 }}>Viz</span>
      <span style={{ fontWeight: 500 }}>Badger</span>
      <span 
        style={{ 
          color: periodColor,
          transition: 'color 0.3s ease',
          marginLeft: '-1px',
          fontSize: '1.1em',
          lineHeight: 1,
        }}
      >
        .
      </span>
    </div>
  );
};
